export const PREVIEW_IN_DXC_TITLE = 'Preview in DXC';
export const FETCH_EXTERNAL_PREVIEW_LINK_FAIL_MESSAGE = 'Failed to fetch Preview Link.';
export const EXPERIENCE_ID_MISSING_MESSAGE = 'Experience ID is missing.';
export const PREVIEW_LINK_IS_NOT_AVAILABLE_MESSAGE = 'Preview link is not available for provided experience id.';
